export default __webpack_public_path__ + "static/media/tutorial_1.499636d6.png";